// extracted by mini-css-extract-plugin
export var back = "shared-module--back--3e18e";
export var blue = "#0eb3f2";
export var button = "shared-module--button--bc9f9";
export var buttons = "shared-module--buttons--182f3";
export var center = "shared-module--center--1085b";
export var clamp = "shared-module--clamp--09217";
export var close = "shared-module--close--a5deb";
export var container = "shared-module--container--80529";
export var content = "shared-module--content--ba6d4";
export var emphasis = "shared-module--emphasis--b7128";
export var eventName = "shared-module--eventName--0b79c";
export var exoticOutcomes = "shared-module--exoticOutcomes--22bb3";
export var exoticTitle = "shared-module--exoticTitle--0531d";
export var footer = "shared-module--footer--41ef5";
export var green = "#57d33b";
export var greenLink = "shared-module--green-link--1b3ef";
export var grey = "var(--tone-mid)";
export var header = "shared-module--header--62652";
export var hidden = "shared-module--hidden--b6197";
export var icon = "shared-module--icon--7d7b9";
export var iconButton = "shared-module--iconButton--063bf";
export var info = "shared-module--info--7e213";
export var isLast = "shared-module--isLast--1f943";
export var isReviewing = "shared-module--isReviewing--c0adf";
export var label = "shared-module--label--f7f2b";
export var largeFooter = "shared-module--largeFooter--7a8f1";
export var legs = "shared-module--legs--1003b";
export var marketName = "shared-module--marketName--0c66b";
export var multiIcon = "shared-module--multiIcon--d58b3";
export var multiSeparator = "shared-module--multiSeparator--101be";
export var notchGap = "32px";
export var orange = "#f8662b";
export var outcomeIcon = "shared-module--outcomeIcon--81791";
export var panel = "shared-module--panel--2c233";
export var pick = "shared-module--pick--fe58e";
export var red = "#ff2741";
export var right = "shared-module--right--31452";
export var scrollArea = "shared-module--scrollArea--afc51";
export var selectionName = "shared-module--selectionName--0e21b";
export var small = "shared-module--small--6d283";
export var smallFooter = "shared-module--smallFooter--76c54";
export var sport = "shared-module--sport--438b8";
export var subOutcome = "shared-module--subOutcome--cf20b";
export var subOutcomes = "shared-module--subOutcomes--75769";
export var tab = "shared-module--tab--3ea3a";
export var tabList = "shared-module--tabList--fa293";
export var tabListContainer = "shared-module--tabListContainer--1b386";
export var tabs = "shared-module--tabs--0859e";
export var title = "shared-module--title--f83b3";
export var trash = "shared-module--trash--0cc8b";
export var value = "shared-module--value--cf7c8";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";